
import React, { useState } from 'react';
import { Icon, Image, Button, Card, Header, Segment, Label } from 'semantic-ui-react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // Import the carousel CSS
import styles from './Post.module.css';

interface Engagement {
    id: number;
    engagementType: string;
}

interface ImageType {
    id: number;
    url: string;
}

interface Poster {
    id: number;
    name: string;
}

interface PostProps {
    id: number;
    title: string;
    description: string;
    engagements: Engagement[];
    images: ImageType[];
    poster: Poster;
}

interface Engagement {
    id: number;
    engagementType: string;
}

interface PostProps {
    id: number;
    title: string;
    description: string;
    engagements: Engagement[];
    images: ImageType[];
    poster: Poster;
}

const Post: React.FC<PostProps> = (props) => {
    // fake it!
    const [isLiked, setIsLiked] = useState(false);
    const [likeCount, setLikeCount] = useState(
        props.engagements.filter(e => e.engagementType === 'LIKE').length
    );

    const handleLikeToggle = () => {
        setIsLiked(prev => !prev);
        setLikeCount(prev => (isLiked ? prev - 1 : prev + 1));
    };

    const otherEngagementsCount = props.engagements.filter(e => e.engagementType !== 'LIKE').length;

    return (
        <Card fluid className={styles.postCard}>
            <Card.Content>
                <Header as='h3' className={styles.posterHeader}>
                    <Icon name='user circle' />
                    <Header.Content>
                        {props.poster.name}
                        <Header.Subheader className={styles.postTitle}>
                            {props.title}
                        </Header.Subheader>
                    </Header.Content>
                </Header>
            </Card.Content>

            {props.images.length > 0 && (
                <div className={styles.imagesContainer}>
                    <Carousel
                        showArrows={props.images.length > 1} // Only show arrows if multiple images exist
                        showThumbs={false}
                        showStatus={false}
                        infiniteLoop={props.images.length > 1}
                        className={styles.postCarousel}
                    >
                        {props.images.map((image) => (
                            <div key={image.id}>
                                <Image
                                    src={image.url}
                                    alt={`Image ${image.id}`}
                                    className={styles.carouselImage}
                                />
                            </div>
                        ))}
                    </Carousel>
                </div>
            )}

            <Card.Content description className={styles.descriptionText}>
                {props.description}
            </Card.Content>

            <Card.Content extra>
                <Segment basic clearing className={styles.actionSegment}>
                    <Button
                        as='div'
                        labelPosition='right'
                        onClick={handleLikeToggle}
                        className={styles.likeButton}
                    >
                        <Button
                            icon
                            color={isLiked ? 'red' : 'grey'}
                        >
                            <Icon name='heart' />
                        </Button>
                        <Label as='a' basic pointing='left' color={isLiked ? 'red' : 'grey'}>
                            {likeCount} {likeCount === 1 ? 'Like' : 'Likes'}
                        </Label>
                    </Button>

                    <span className={styles.engagementSummary}>
                        <Icon name='comment outline' />
                        {otherEngagementsCount} Other Engagements
                    </span>
                </Segment>
            </Card.Content>
        </Card>
    );
};

export { Post };
